import { Component } from 'react';
import { compose } from 'recompose';

import { GetUserSocialConnectionsDocument } from 'api';
import { withApolloClient, withUser, IWithApolloClient, IWithUser } from 'providers';
import { CONNECTION_SUCCESS_MESSAGE, NULL } from 'constants/index';

interface IPropsEnhanced extends IWithUser, IWithApolloClient {}

const enhancers = compose<IPropsEnhanced, {}>(withUser, withApolloClient);

class Connections extends Component<IPropsEnhanced> {
  componentDidMount() {
    window.addEventListener('message', this.updateConnections, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.updateConnections, false);
  }

  updateConnections = async (event: MessageEvent) => {
    if (event.data !== CONNECTION_SUCCESS_MESSAGE) {
      return;
    }

    const { apolloClient, user } = this.props;
    const { query } = apolloClient;
    const variables = { user_id: user.id };

    await query({
      fetchPolicy: 'network-only',
      query: GetUserSocialConnectionsDocument,
      variables,
    });
  };

  render() {
    return NULL;
  }
}

export default enhancers(Connections);
